import React, { Component } from 'react';
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
// core components
import { Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getCategoryDetails,
  getSuperCategory as getCategoryList,
  updateCategory,
  upload
} from '../../store/actions/vendor/Vendor';
import CardHeader from '../../components/Card/CardHeader.js';
import CardBody from '../../components/Card/CardBody.js';
import CardFooter from '../../components/Card/CardFooter.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

class CategoryEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUploadMessage: '',
      categoryDetail: {
        name: 'loading..',
        superCategoryId: '63c0eeb0-206b-11eb-97d7-7dadae6d1a71',
        categoryId: '63c0eeb0-206b-11eb-97d7-7dadae6d1a71',
        icon: 'https://inolemit.sirv.com/utils/35%20(1).gif'
      }
    };
  }

  componentDidMount() {
    var categoryId = this.props.match.params.categoryId;
    this.props.getCategoryDetails(categoryId);
    this.props.getCategoryList();
    this.getDetails(
      this.props.match.params.superCategoryId,
      this.props.match.params.categoryId
    );
  }

  getDetails = (superCategoryId, categoryId) => {
    if (this.props.categoryDetails > 0) {
      setTimeout(() => {
        this.setState((prevState) => ({
          categoryDetail: {
            ...prevState.categoryDetail,
            superCategoryId: this.props.categoryDetails.superCategoryId,
            categoryId: this.props.categoryDetails.id,
            name: this.props.categoryDetails.name,
            icon: this.props.categoryDetails.icon
          }
        }));
      }, 7000);
    } else {
      setTimeout(() => {
        this.setState((prevState) => ({
          categoryDetail: {
            ...prevState.categoryDetail,
            superCategoryId: this.props.categoryDetails.superCategoryId,
            categoryId: this.props.categoryDetails.id,
            name: this.props.categoryDetails.name,
            icon: this.props.categoryDetails.icon
          }
        }));
      }, 7000);
    }
  };

  handleChange = (event) => {
    const id = event.target.id;
    this.setState({
      ...this.state.categoryDetail,
      [id]: event.target.value
    });
  };
  onUpload = (event) => {
    this.setState({
      imageUploadMessage: 'Uploading the file, please wait...'
    });

    let data = new FormData();
    data.append('files', event.target.files[0]);

    // Upload image
    this.props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          this.setState({
            imageUploadMessage: 'File uploaded successfully.'
          });
          let categoryDetail = this.state.categoryDetail;
          categoryDetail.icon = `${response.data.uploads[0].path}`;
          this.setState({
            categoryDetail
          });
        } else {
          this.setState({
            imageUploadMessage: 'Please, try Again'
          });
        }
      })
      .catch((error) => {
        this.setState({
          imageUploadMessage:
            'An error occurred while executing the query. Please try Again'
        });
      })
      .then(() => {
        console.log('Image uploaded');
      });
  };

  onChange = (event) => {
    let categoryDetail = this.state.categoryDetail;
    categoryDetail[event.target.name] = event.target.value;

    this.setState({
      categoryDetail
    });
  };
  onSubmit = (event) => {
    event.preventDefault();
    // Update CategoryDetail
    this.props.updateCategory(this.state.categoryDetail);
    setTimeout(() => {
      this.props.history.push(
        `/vendor/all-category/${this.state.categoryDetail.superCategoryId}`
      );
    }, 3000);
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>Update a Category</h4>
          <p className={classes.cardCategoryWhite}>
            When choosing icon, PNG images would be better over JPG or imap
          </p>
        </CardHeader>
        <CardBody>
          <br />
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                labelText="Category Name"
                value={this.state.categoryDetail.name}
                onChange={this.onChange}
                name="name"
                id="name"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText="Category Icon"
                id="icon"
                type="file"
                name="icon"
                accept="image/png, image/jpeg, image/jpg"
                onChange={this.onUpload}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </GridItem>
            <br />
            <p style={{ color: '#000' }}>{this.state.imageUploadMessage}</p>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button
            type="submit"
            onClick={this.onSubmit}
            style={{
              color: '#fff',
              backgroundColor: '#9c27b0',
              boxShadow:
                '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
            }}
          >
            Update Category
          </Button>
        </CardFooter>
        <br /> <br />
        <Table hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Icon</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>1</th>
              <td>{this.state.categoryDetail.name}</td>
              <td>
                <img
                  src={this.state.categoryDetail.icon}
                  style={{ height: '70px' }}
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </>
    );
  }
}

const mapStateWithProps = (state) => ({
  categoryDetails: state.vendor.categoryDetails,
  superCategories: state.vendor.superCategories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList()),
    getCategoryDetails: (categoryId) =>
      dispatch(getCategoryDetails(categoryId)),
    updateCategory: (categoryData) => dispatch(updateCategory(categoryData)),
    upload: (data) => dispatch(upload(data))
  };
};

export default compose(
  connect(mapStateWithProps, mapDispatchWithProps),
  withStyles(styles)
)(CategoryEdit);
